export const CACHE_TABLE_ID = "cacheTableID";
export const attributes = [
  {
    id: "title",
    title: "Title",
    type: "STRING",
    searchable: true
  },
  {
    id: "description",
    title: "Description",
    type: "STRING"
  },
  {
    id: "name",
    title: "Name",
    type: "STRING"
  },
  {
    id: "entries",
    title: "Entries"
  },
  {
    id: "hit_rate",
    title: "Hit Rate"
  },
  {
    id: "throughput",
    title: "Throughput"
  }
];
export const cacheListElements = {
  defaultLayout: {
    entityTableId: CACHE_TABLE_ID,
    defaultPageSize: 20,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: ["title", "description", "name", "entries", "hit_rate", "throughput"],
    defaultColumnOrder: ["title", "description", "name", "entries", "hit_rate", "throughput"]
  }
};
